// src/router/index.js
import Vue from 'vue';
import VueRouter from 'vue-router';
import CookieUtil from '@/utils/CookieUtil';
import config from '@/utils/Config';
import { post } from '@/utils/request';

import Home from '@/pages/home/Home.vue'
import Admin from '@/pages/admin/Admin.vue';
import Instr from '@/pages/instr/Instr.vue';
import Nature from '@/pages/nature/Nature.vue';
import Login from '@/pages/login/Login.vue';
import Analysis from '@/pages/analysis/Analysis.vue';
import Comments from '@/pages/comments/Comments.vue';
import Life from '@/pages/life/Life.vue';
import Pub from '@/pages/pub/Pub.vue';
import Danmaku from '@/pages/danmaku/Danmaku.vue';
import Verlog from '@/pages/verlog/Verlog.vue';
import Searchbing from '@/pages/searchbing/Searchbing.vue';
import Transfer from '@/pages/transfer/Transfer.vue';
import Mine from '@/pages/games/mine/Mine.vue';
import LifeDetail from '@/pages/life-detail/LifeDetail.vue';
import Music from '@/pages/music/Music.vue';
import Travels from '@/pages/travels/Travels.vue';
import PubTravels from '@/pages/pub-travels/PubTravels.vue';
import TravelDetail from '@/pages/travel-detail/TravelDetail.vue';


Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Searchbing',
        component: Searchbing
    },
    {
        path: '/home',
        name: 'Home',
        component: Home
    },
     {
        path: '/transfer',
        name: 'Transfer',
        component: Transfer
    },
    {
        path: '/pub',
        name: 'Pub',
        component: Pub,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/pub-travels',
        name: 'pubTravels',
        component: PubTravels,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/verlog',
        name: 'Verlog',
        component: Verlog
    },
    {
        path: '/travels',
        name: 'Travels',
        component: Travels
    },
    {
        path: '/mine',
        name: 'Mine',
        component: Mine
    },
    {
        path: '/life',
        name: 'Life',
        component: Life
    },
    {
        path: '/life-detail',
        name: 'LifeDetail',
        component: LifeDetail
    },
    {
        path: '/travel-detail',
        name: 'TravelDetail',
        component: TravelDetail
    },
    {
        path: '/music',
        name: 'Music',
        component: Music
    },
    {
        path: '/danmaku',
        name: 'Danmaku',
        component: Danmaku
    },
    {
        path: '/instr',
        name: 'Instr',
        component: Instr
    },
    {
        path: '/nature',
        name: 'Nature',
        component: Nature
    },
    {
        path: '/analysis',
        name: 'Analysis',
        component: Analysis
    },
    {
        path: '/admin',
        name: 'Admin',
        component: Admin,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/comments',
        name: 'Comments',
        component: Comments
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    }
];

const router = new VueRouter({
    mode: 'history', // 使用HTML5 History模式
    base: process.env.BASE_URL,
    routes
});


// 路由守卫， 对指定路由进行登录校验， 未登录则跳转登录界面
router.beforeEach((to, from, next) => {
    // 获取用户token
    const token = CookieUtil.get(config.TOKEN_KEY);
    const loginFlag = !!token;
    if (to.matched.some(record => record.meta.requiresAuth) && !loginFlag) {
        next({ name: 'Login' });
    } else if (to.matched.some(record => record.meta.requiresAuth)) {
        // 验证token有效性
        const tokenFlag = post(config.BASE_URL, config.verifyTokenUrl, {});
        if (!tokenFlag) {
            next({ name: 'Login' });
            return;
        }
        next();
    } else {
        next();
    }
})

export default router;